<template>
  <b-button :variant="variant" @click="$emit('click')" :disabled="disabled">
    <slot></slot>
  </b-button>
</template>

<script>
import { BButton } from 'bootstrap-vue';

export default {
  components: {
    BButton,
  },
  props: {
    variant: { type: String, default: 'primary' },
    disabled: { type: Boolean, default: false },
    isShowIcon: { type: Boolean, default: true },
  },
};
</script>

<style lang="scss" scoped>
button {
  display: flex;
  align-items: center;
  margin-right: 6px;

  @include respond(phone) {
    font-size: 14px;
  }

  & > svg {
    margin-right: 1px;
  }
}
</style>
